import { PrismicRichText } from '@prismicio/react';
import Plyr from 'plyr';
import { useEffect, useRef } from 'react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { SectionWrapper as SectionWrapperRaw } from 'remote-com-shared/components/SectionWrapper';
import { transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { Title } from './BenefitsIntroSlice';

import { fieldHasContent } from '@/src/domains/prismic/helpers';
import 'plyr/dist/plyr.css';

const SectionWrapper = styled(SectionWrapperRaw)`
  background: var(--primaryColor);
  text-align: center;
  ${fluidProp(['padding-top', 'padding-bottom'], '32px', '64px')}
`;

const VideoWrapper = styled.div`
  ${fluidProp('margin-top', '36px', '64px')}
  margin: auto;
  max-width: 960px;
  position: relative;
  rgba(14, 9, 47, 0.33);

  .plyr__control--overlaid {
    background: var(--colors-irisBlue);
  }
  .plyr--full-ui input[type='range'] {
    color: var(--colors-irisBlue);
  }
  .plyr__control {
    &:hover {
      background: var(--colors-irisBlue);
    }
  }
`;

const Video = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const VideoEmbed = ({ videoId }) => {
  const plyrRef = useRef(null);

  useEffect(() => {
    if (!plyrRef.current) return;

    plyrRef.current.plyr = new Plyr(`#player-js-${videoId}`, { captions: { active: true } });

    plyrRef.current.dataset.plyrEmbedId = videoId;
  }, [plyrRef, videoId]);

  return (
    <VideoWrapper>
      <Video data-plyr-provider="vimeo" ref={plyrRef} id={`player-js-${videoId}`} />
    </VideoWrapper>
  );
};

export function VideoEmbedSlice({ slice }) {
  const { primary } = transformProperties(slice);

  const { videoEmbedLink, title } = primary;

  return (
    <SectionWrapper>
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        <VideoEmbed videoId={videoEmbedLink} />
      </ContentContainer>
    </SectionWrapper>
  );
}
